export default __webpack_public_path__ + "static/media/icon-edit.bfb36df2.svg";